import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  FiAlignRight,
  FiXCircle,
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";
import "./Navbarmenu.css";
import { useMsal } from "@azure/msal-react";
import { baseUrl } from "../../Constants";
import axios from "axios";
import mailData from "../../data/mailData";
const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);

 const { instance } = useMsal();
const activeAccount = instance.getActiveAccount();

const loggedInUserEmail =
  activeAccount?.idTokenClaims?.preferred_username ||
  activeAccount?.idTokenClaims?.email ||
  activeAccount?.username ||
  "";
    const allowedUsersForContibution = [
        `${mailData.aayushiBharti}`,
        `${mailData.akashAluru}`,
        `${mailData.ankurMishra}`,
        `${mailData.arpitaSingh}`,
        `${mailData.jeevadhariniRamanan}`,
        `${mailData.reshmiHaridas}`,
        `${mailData.srinivasanHarini}`,
        `${mailData.umaraniBattu}`,
        `${mailData.varshaTyagi}`,
        `${mailData.aayushiBhartiDs}`,
        `${mailData.akashAluruDs}`,
        `${mailData.ankurMishraDs}`,
        `${mailData.arpitaSinghDs}`,
        `${mailData.jeevadhariniRamananDs}`,
        `${mailData.reshmiHaridasDs}`,
        `${mailData.srinivasanHariniDs}`,
        `${mailData.umaraniBattuDs}`,
        `${mailData.varshaTyagiDs}`
    ];

  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const [temp,setTemp] = useState("");
  
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }
   useEffect(()=>{
   const homeUrl =async()=>{
   const res = await axios.get(`${baseUrl}/homeUrl`,{
    })
    setTemp(res.data.Url)
  }
   homeUrl()

  },[])

  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row-fluid">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
               <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    href={temp?temp:""}
                    target="_blank"
                  >
                    <span className="underline">L&TT Home</span>
                  </a>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/home`}
                  >
                    Home
                  </NavLink>
                </li>
                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  {" "}
                  <NavLink
                    className="nav-links"
                    to="/learnings"
                    activeClassName="is-active"
                  >
                    {" "}
                    Learnings{" "}
                    <span>
                      <FiChevronDown />
                    </span>{" "}
                  </NavLink>
                  <ul className={boxClassSubMenu.join(" ")}>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/learnings"
                      >
                        {" "}
                        European Learning{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/japaneseLearning"
                      >
                        {" "}
                        Japanese Learning{" "}
                      </NavLink>{" "}
                    </li>
                  </ul>
                </li>
                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  {" "}
                  <NavLink
                    className="nav-links"
                    to="/dashboard"
                    activeClassName="is-active"
                  >
                    {" "}
                    Dashboard{" "}
                    <span>
                      <FiChevronDown />
                    </span>{" "}
                  </NavLink>
                  <ul className={boxClassSubMenu.join(" ")}>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/dashboard"
                      >
                        {" "}
                        European Dashboard{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/dashboardJapanese"
                      >
                        {" "}
                        Japanese Dashboard{" "}
                      </NavLink>{" "}
                    </li>
                  </ul>
                </li>

                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/ourTeam`}
                  >
                    Meet the Team
                  </NavLink>
                </li>

                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/wallOfFame`}
                  >
                    Wall of Fame
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/learningBytes`}
                  >
                    Learning Bytes
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/faqs`}
                  >
                    FAQs
                  </NavLink>
                </li>
                {allowedUsersForContibution.includes(loggedInUserEmail) && (
                  <li className="menu-item">
                    <NavLink
                      className="nav-links"
                      onClick={toggleClass}
                      to={`/analytics`}
                    >
                      Analytics
                    </NavLink>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
